<template>
  <div id="home-page">
    <TabSection />
    <div class="browse-categories-section">
      <Categories />
    </div>
    <Stats
      v-if="(siteStats && siteStats.length) || (herdStats && herdStats.length)" 
      :siteStats="siteStats"
      :herdStats="herdStats"
    />
    <div class="pony-pic-border"></div>
    <Register v-if="!authenticated" />
  </div>
</template>

<script>
import Stats from '../../components/Stats/Stats';
import TabSection from '../../components/TabSection/TabSection';
import Categories from '../../components/Categories/Categories';
import Register from '../../components/Register/Register';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Home',
  components: {
    Stats,
    TabSection,
    Register,
    Categories
  },
  mounted() {
    this.ADD_STATS();
  },
  computed: {
    ...mapState('currentUser', ['authenticated']),
    ...mapState('herdStats', { herdStats: 'stats' }),
    ...mapState('siteStats', { siteStats: 'stats' }),
  },
  methods: {
    ...mapActions('siteStats', ['ADD_STATS']),
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/config';

.browse-categories-section {
  background: url('../../assets/images/home-category-section-bg.jpg');
  background-size: cover;
  background-attachment: fixed;
}

.pony-pic-border {
  width: 100%;
  height: 142px;
  background: url('../../assets/images/photo-divider.jpg') repeat-x;
}
</style>

<style lang="scss">

.home-category-content {
  .inline-list-item a {
      color: #fff;
  }
}
</style>
